import { Button, Stack } from "@mui/material";
import React, { useCallback } from "react";
import Modal, { CommonModalProps } from "..";
import FormInputText from "../../Forms/FormInputText/form-input-text";
import { GetSectionIsValid } from "../../../Redux/Reducers/redux-slice-form-validation";
import { useAppSelector } from "../../../Redux/redux-store";
import { assetService } from "../../../Core/Api/services";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { useTranslation } from "react-i18next";

export type ModalRenameObjectElementProps = {
  objectId: number;
  nameInitial: string;
  onConfirm?: (name: string) => void;
};

export type ModalRenameObjectProps = CommonModalProps<ModalRenameObjectElementProps>;

const ModalRenameObject = React.forwardRef<any, ModalRenameObjectProps>((props, ref) => {
  const { t } = useTranslation();
  const { objectId, nameInitial, closeModal, onConfirm, ...modalProps } = props;
  const [name, setName] = React.useState<string>(nameInitial);
  const enqueueCustomSnackbar = useCustomSnackbar();

  const isValid = useAppSelector(GetSectionIsValid("form-confirm", "sectionComment"));

  const updateInputValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleConfirmClick = useCallback(() => {
    assetService
      .Rename({
        objectId: objectId,
        name: name,
      })
      .then((response) => {
        if (response.success) {
          enqueueCustomSnackbar(t("alert:success.itemRenamed"), "success");
          onConfirm && onConfirm(name);
        } else enqueueCustomSnackbar(t("alert:error.errorRenaming", { message: response.message }), "error");
      });
    closeModal();
  }, [objectId, name]);

  const handleCancelClick = () => {
    closeModal();
  };

  return (
    <Modal
      title={t("common:rename")}
      reference={ref}
      closeModal={handleCancelClick}
      width={504}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button onClick={handleCancelClick}>{t("common:cancel")}</Button>
          <Button color="success" variant="outlined" onClick={handleConfirmClick} disabled={!isValid}>
            {t("common:confirm")}
          </Button>
        </Stack>
      }
    >
      <Stack spacing={1}>
        <FormInputText
          value={name}
          onChange={updateInputValue}
          placeholder={t("field:placeholder.typeItemName")}
          rows={3}
          validationProps={{
            formId: "form-confirm",
            formSectionId: "sectionComment",
            fieldId: "comment",
            initialState: false,
            required: true,
            minLength: 3,
          }}
        />
      </Stack>
    </Modal>
  );
});

export default ModalRenameObject;
